import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { PageHero } from "@/components/common/Bits";
import { SERVICES, SPECIAL_SOLUTIONS } from "@/data/services";
import { usePosts, useProjects } from "@/hooks/useContent";

const Group = ({ title, links }) => (
    <div>
        <h2 className="font-display text-xl font-semibold text-brand-blue">{title}</h2>
        <ul className="mt-4 space-y-2">
            {links.map((l) => (
                <li key={l.to}>
                    <Link to={l.to} className="text-sm text-brand-ink/70 transition-colors hover:text-brand-red">{l.label}</Link>
                </li>
            ))}
        </ul>
    </div>
);

export default function Sitemap() {
    const { data: posts } = usePosts();
    const { data: projects } = useProjects();

    return (
        <>
            <SEO title="Sitemap" path="/sitemap" description="Browse all pages of the ProCare.SG website." />
            <PageHero label="Sitemap" title="Find Your Way Around" subtitle="Every page on the ProCare.SG website, in one place." />
            <section className="py-20">
                <div className="mx-auto grid max-w-7xl gap-10 px-6 sm:grid-cols-2 lg:grid-cols-4">
                    <Group title="Main" links={[
                        { to: "/", label: "Home" },
                        { to: "/about-us", label: "About Us" },
                        { to: "/our-works", label: "Our Works" },
                        { to: "/testimonials", label: "Testimonials" },
                        { to: "/blog", label: "Blog" },
                        { to: "/contact", label: "Contact" },
                    ]} />
                    <Group title="Services" links={SERVICES.map((s) => ({ to: `/services/${s.slug}`, label: s.name }))} />
                    <Group title="Special Solutions" links={SPECIAL_SOLUTIONS.map((s) => ({ to: `/special-solutions/${s.slug}`, label: s.name }))} />
                    <div className="space-y-10">
                        <Group title="Blog Articles" links={posts.map((p) => ({ to: `/blog/${p.slug}`, label: p.title }))} />
                        <Group title="Legal" links={[
                            { to: "/privacy-policy", label: "Privacy Policy" },
                            { to: "/terms-of-use", label: "Terms of Use" },
                        ]} />
                    </div>
                    <div className="sm:col-span-2 lg:col-span-4">
                        <Group title="Projects" links={projects.map((p) => ({ to: `/our-works/${p.slug}`, label: p.title }))} />
                    </div>
                </div>
            </section>
        </>
    );
}
